const version = "2.6.1";

export { version };
//# sourceMappingURL=version.mjs.map
